import { logToSentry } from './utils'

export const clearZendeskIdentity = () => {
  // Resolve the live SDK each time; the initial command queue can be replaced.
  const messenger = (window as any).zE
  if (!messenger) return
  try {
    try {
      messenger('messenger', 'hide')
    } finally {
      // A failure to hide the launcher must not prevent clearing the user's session.
      messenger('messenger', 'logoutUser')
    }
  } catch {
    logToSentry('zendeskWidgetError', { message: 'Failed to clear Zendesk Messaging identity', type: 'error' })
  }
}
